import { ThemeOptions } from '@mui/material';
import { capitalDesignTokens } from '@opengov/capital-design-tokens';

declare module '@mui/material/FormControl' {
  interface FormControlPropsSizeOverrides {
    large: true;
  }
}

/**
 * Theme override for MUI FormControl component
 *
 * Size support:
 * - Small: 32px
 * - Medium: 36px (default)
 * - Large: 44px
 */
export const MuiFormControl: ThemeOptions['components']['MuiFormControl'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      // Ensure label has the correct size - Select needs this to be consistent with TextField label behavior
      '& .MuiInputLabel-formControl, & .MuiInputLabel-shrink': {
        ...(ownerState.size === 'small' && {
          fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall
        })
      }
    })
  }
};
